import React from "react";
import { GoDot } from "react-icons/go";

const EligibilityGuidelines = () => {
  return (
    <div className="font-jost h-full w-full">
      <div className="flex w-full flex-col text-justify">
        <div>
          <h1 className="p-2 text-center text-4xl">Eligibility Requirements</h1>
        </div>
        <div className="flex w-full flex-col items-start justify-center gap-3 px-5 py-3">
          <ul className="flex list-disc flex-col gap-3 px-2 text-justify sm:px-10">
            <li>
              The applicant is an ISKCON devotee or a sincere aspirant
              endeavouring to progress in Krishna consciousness under
              appropriate spiritual guidance.
            </li>
            <li>
              The applicant regularly chants the Hare Krishna Mahamantra and
              maintains a sincere commitment to devotional practices.
            </li>
            <li>
              The applicant follows, or is sincerely striving to follow, the
              four regulative principles under appropriate spiritual
              guidance.
            </li>
            <li>
              The applicant meets the legal age requirement for marriage as
              prescribed by applicable law.
            </li>
            <li>
              The applicant is willing to provide, if requested, a
              recommendation from a spiritual mentor or recognized devotee
              authority as part of the profile verification process.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default EligibilityGuidelines;